const elementsOptions = {
	point: {
		borderWidth: 2
	}
};

export default elementsOptions;